// Copyright 2022, Imprivata, Inc.  All rights reserved.
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@imprivata-cloud/design-system/style.css';
import { Provider as ReduxProvide } from 'react-redux';
import Main from './Main';
import { LocaleProvider } from './i18n/localeProvider';
import { attachAgentMockIfNeeded } from './endpoint-agent-mock';
import { configureStore } from './store/configureStore';
import { migrateLegacyCodingContext } from './services/codingContextStorage';
import './tracing';

attachAgentMockIfNeeded();
migrateLegacyCodingContext();

const store = configureStore();

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ReduxProvide store={store}>
      <LocaleProvider>
        <Main />
      </LocaleProvider>
    </ReduxProvide>
  </React.StrictMode>,
);
